// Queries Shopify's semantic predictive search misreads (handled = 'handheld' -> massage guns) - 2026-10-26
// Body-area words -> category: the dropdown shows that category's products (same as the circle menu) - 2026-10-26
const OB_PS_CATEGORY = {"sv":{"axel":"axel","armbåge":"armbage","fot":"fotter-tar","fot & tå":"fotter-tar","tå":"fotter-tar","knä":"knaskydd","handled":"hand-handled","fingrar":"fingrar","nacke":"rygg-nacke","rygg":"rygg-nacke","rygg & nacke":"rygg-nacke","höft":"hoft","kompressionsstöd":"kompressionsstod","höften":"hoft","höfter":"hoft","knät":"knaskydd","knäna":"knaskydd","knän":"knaskydd","axeln":"axel","axlar":"axel","axlarna":"axel","ryggen":"rygg-nacke","nacken":"rygg-nacke","fötter":"fotter-tar","fötterna":"fotter-tar","foten":"fotter-tar","tår":"fotter-tar","tårna":"fotter-tar","handleden":"hand-handled","handleder":"hand-handled","finger":"fingrar","fingret":"fingrar","fingrarna":"fingrar","armbågen":"armbage","armbågar":"armbage","höftstöd":"hoft","höftskydd":"hoft","höftortos":"hoft","höftsmärta":"hoft"},"da":{"skulder":"axel","albue":"armbage","fod":"fotter-tar","fod & tå":"fotter-tar","tå":"fotter-tar","knæ":"knaskydd","håndled":"hand-handled","fingre":"fingrar","nakke":"rygg-nacke","ryg":"rygg-nacke","ryg & nakke":"rygg-nacke","hofte":"hoft","kompressionsstøtte":"kompressionsstod","hofter":"hoft","knæet":"knaskydd","skuldre":"axel","fødder":"fotter-tar","tæer":"fotter-tar","finger":"fingrar","hoftestøtte":"hoft","hoftebind":"hoft"},"nb":{"skulder":"axel","albue":"armbage","fot":"fotter-tar","fot & tå":"fotter-tar","tå":"fotter-tar","kne":"knaskydd","håndledd":"hand-handled","fingre":"fingrar","nakke":"rygg-nacke","rygg":"rygg-nacke","rygg & nakke":"rygg-nacke","hofte":"hoft","kompresjonstøtte":"kompressionsstod","hofter":"hoft","kneet":"knaskydd","skuldre":"axel","føtter":"fotter-tar","tær":"fotter-tar","finger":"fingrar","hoftestøtte":"hoft"},"fi":{"olkapää":"axel","kyynärpää":"armbage","jalka":"fotter-tar","jalka & varvas":"fotter-tar","varvas":"fotter-tar","polvi":"knaskydd","ranne":"hand-handled","sormet":"fingrar","niska":"rygg-nacke","selkä":"rygg-nacke","selkä & niska":"rygg-nacke","lonkka":"hoft","kompressiotuki":"kompressionsstod","lonkat":"hoft","polvet":"knaskydd","olkapäät":"axel","jalat":"fotter-tar","varpaat":"fotter-tar","sormi":"fingrar","lonkkatuki":"hoft"},"nl":{"schouder":"axel","elleboog":"armbage","teen":"fotter-tar","voet":"fotter-tar","voet & teen":"fotter-tar","knie":"knaskydd","pols":"hand-handled","vingers":"fingrar","nek":"rygg-nacke","rug":"rygg-nacke","rug & nek":"rygg-nacke","heup":"hoft","compressie":"kompressionsstod","heupen":"hoft","knieën":"knaskydd","schouders":"axel","voeten":"fotter-tar","tenen":"fotter-tar","vinger":"fingrar","heupsteun":"hoft","heupbrace":"hoft","heuppijn":"hoft"},"fr":{"épaule":"axel","coude":"armbage","orteil":"fotter-tar","pied":"fotter-tar","pied & orteil":"fotter-tar","genou":"knaskydd","poignet":"hand-handled","doigts":"fingrar","dos":"rygg-nacke","dos & nuque":"rygg-nacke","nuque":"rygg-nacke","hanche":"hoft","compression":"kompressionsstod","hanches":"hoft","genoux":"knaskydd","épaules":"axel","epaule":"axel","pieds":"fotter-tar","orteils":"fotter-tar","doigt":"fingrar","coudes":"armbage","poignets":"hand-handled","douleur hanche":"hoft","maintien hanche":"hoft"}};
function obPsCategory(term) {
  const lang = (document.documentElement.lang || 'sv').toLowerCase().slice(0, 2);
  return (OB_PS_CATEGORY[lang] || {})[term.trim().toLowerCase().replace(/\s+/g, ' ')];
}
const OB_PS_REWRITE = { 'handled': 'handledsstöd', 'handleden': 'handledsstöd', 'håndled': 'håndledsstøtte', 'håndleddet': 'håndledsstøtte', 'håndledd': 'håndleddsstøtte' };

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.contains(document.activeElement)) return;
      // Mobile search modal: keyboard 'Done'/scroll only blurs the input (focus goes nowhere) - keep the results open
      const focusGoneNowhere = !document.activeElement || document.activeElement === document.body;
      if (focusGoneNowhere && this.closest('.search-modal')) return;
      this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(OB_PS_REWRITE[searchTerm.trim().toLowerCase()] || searchTerm)}&section_id=predictive-search&resources[limit]=8&resources[limit_scope]=each`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const cat = obPsCategory(searchTerm);
        const list = doc.querySelector('#predictive-search-results-products-list');
        if (!cat || !list) return doc;
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return fetch(`${root}collections/${cat}?view=ob-ps`, { signal: this.abortController.signal })
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const items = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-ob-ps-coll] > li');
            if (items.length >= 3) {
              list.innerHTML = '';
              items.forEach((li, i) => { li.id = `predictive-search-option-product-${i + 1}`; list.appendChild(li); });
            }
            return doc;
          })
          .catch((e) => { if (e?.code === 20) throw e; return doc; });
      })
      .then((doc) => {
        const resultsMarkup = doc.querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    obFitSearchResults();
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

// Search modal (mobile/tablet): keep the results list inside the visible area, above the on-screen keyboard - 2026-10-26
function obFitSearchResults() {
  if (!window.visualViewport) return;
  document.querySelectorAll('.search-modal predictive-search[open] [data-predictive-search]').forEach((el) => {
    const visibleBottom = window.visualViewport.offsetTop + window.visualViewport.height;
    const h = Math.floor(visibleBottom - el.getBoundingClientRect().top - 8);
    if (h > 150) el.style.setProperty('max-height', `${h}px`, 'important');
  });
}
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', obFitSearchResults);
  window.visualViewport.addEventListener('scroll', obFitSearchResults);
  window.addEventListener('resize', obFitSearchResults);
  // Keyboard opens/closes on focus/blur; refit after its animation
  ['focusin', 'focusout'].forEach((type) =>
    document.addEventListener(type, (event) => {
      if (!event.target.closest || !event.target.closest('.search-modal')) return;
      [150, 400, 800].forEach((ms) => setTimeout(obFitSearchResults, ms));
    })
  );
}
